// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__ze2Mc","left":"About_left__wDz-a","right":"About_right__iPLOL"};